var map = {
	"./bonus_symbol_0.png": 49787,
	"./bonus_symbol_1.png": 84434,
	"./bonus_symbol_2.png": 49577,
	"./bonus_symbol_3.png": 94752,
	"./bonus_symbol_4.png": 53407
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31874;